/**
 * session.js
 * Written by: Alex Kasemir
 */

import userActions from '../../actions';

/**
 * Using canoe for starting reference
 */
const initialState = {
  authLoading: false,
  authedUserId: null,
  loggedin: false,
  subscribed: false,
  sessionLoaded: false,
  sessionLoading: false,
  statsLoaded: false,
  statsLoading: false,
  bestWorstLoading: false,
  bestWorstLoaded: false,
  statsByQuizLoaded: false,
  statsByQuizLoading: false,
  questionsLoaded: false,
  questionsLoading: false,
  userPreferencesLoading: false,
  userPreferencesLoaded: false,
};

const session = (state = initialState, action) => {
  switch (action.type) {
    case userActions.FACEBOOK_LOGIN_START:
    case userActions.GMAIL_LOGIN_START:
      return {
        ...state,
        authLoading: true,
      };
    case userActions.AUTHENTICATE_FACEBOOK_SUCCESS:
    case userActions.AUTHENTICATE_GMAIL_SUCCESS:
      return {
        ...state,
        loggedin: true,
        authLoading: false,
      };
    case userActions.AUTHENTICATE_FACEBOOK_FAILURE:
    case userActions.AUTHENTICATE_GMAIL_FAILURE:
      return {
        ...state,
        loggedin: false,
      };
    case userActions.SET_AUTHED_USER:
      return {
        ...state,
        authedUserId: action.id,
      };
    case userActions.LOAD_SESSION_START:
      return {
        ...state,
        sessionLoading: true,
      };
    case userActions.LOAD_SESSION_SUCCESS:
      return {
        ...state,
        sessionLoaded: true,
        sessionLoading: false,
      };
    case userActions.LOAD_SESSION_FAILURE:
    case userActions.LOGOUT_SUCCESS:
    case userActions.REMOVE_TOKEN_SUCCESS:
      return {
        ...initialState,
      };
    case userActions.GET_USER_STATS_START:
      return {
        ...state,
        statsLoading: true,
      };
    case userActions.GET_USER_STATS_SUCCESS:
      return {
        ...state,
        statsLoading: false,
        statsLoaded: true,
      };
    case userActions.GET_USER_BEST_WORST_START:
      return {
        ...state,
        bestWorstLoading: true,
      };
    case userActions.GET_USER_BEST_WORST_SUCCESS:
    case userActions.GET_USER_BEST_WORST_FAILURE:
      return {
        ...state,
        bestWorstLoading: false,
        bestWorstLoaded: true,
      };
    case userActions.GET_USER_STATS_BY_CATEGORY_START:
      return {
        ...state,
        statsByQuizLoading: true,
        statsByQuizLoaded: false,
      };
    case userActions.GET_USER_STATS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        statsByQuizLoading: false,
        statsByQuizLoaded: true,
      };
    case userActions.GET_USER_PREFERENCES_START:
      return {
        ...state,
        userPreferencesLoading: true,
      };
    case userActions.GET_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        userPreferencesLoading: false,
        userPreferencesLoaded: true,
      };
    case userActions.GET_USER_QUESTIONS_START:
      return {
        ...state,
        questionsLoading: true,
      };
    case userActions.GET_USER_QUESTIONS_SUCCESS:
      return {
        ...state,
        questionsLoading: false,
        questionsLoaded: true,
      };
    case userActions.GET_USER_BADGES_START:
      return {
        ...state,
        badgesLoading: true,
      };
    case userActions.GET_USER_BADGES_SUCCESS:
      return {
        ...state,
        badgesLoading: false,
        badgesLoaded: true,
      };
    case `CREATE_SUBSCRIBER_SUCCESS`:
      return {
        ...state,
        subscribed: true,
      };
    default:
      return state;
  }
};

export default session;
